import { RequestConfig } from '~/common/services/requests';
import { PlatformRequestOptions } from '../../../contexts/RequestsContext';
import { Workflow } from '../../../types';
import { buildHeadersFromDocumentParams } from '../../documents/logic/buildHeadersFromDocumentParams';
import { DocumentParams } from '../../documents/types/DocumentParams';
import { ConstructGet } from '../../types/ConstructGet';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { WORKFLOWS_BASE_PATH } from '../constants/workflowsBasePath';

export const getWorkflow = async (
  constructGet: ConstructGet,
  documentParams: DocumentParams,
  documentId: string,
  workflowName: string | undefined,
  params?: RequestConfig['params'],
  options?: PlatformRequestOptions,
): Promise<NonPaginatedResponse<Workflow> | undefined> => {
  if (!workflowName) {
    return undefined;
  }

  return constructGet<NonPaginatedResponse<Workflow>>(
    `${WORKFLOWS_BASE_PATH}/${documentId}/workflow/${workflowName}`,
    {
      params,
      headers: buildHeadersFromDocumentParams(documentParams),
    },
    options,
  );
};
